/**
 * Asynchronously loads the component for HomePage
 */

 import { lazyLoad } from 'utils/loadable';

 export const TermsAndConditions = lazyLoad(
   () => import('./index'),
   module => module.TermsAndConditions,
 );
 